import {Injectable} from '@angular/core';
import {TranslateDefaultParser} from "@ngx-translate/core";

/**
 * Service for handling java resource bundle interpolation parameters, like {0}
 */
@Injectable({
  providedIn: 'root'
})
export class RbTranslateParserService extends TranslateDefaultParser {

  constructor() {
    super();
  }


  interpolate(expr: string | Function, params?: any): string {
    if (typeof expr === "string") {
      expr = expr.replace(/{(\d+)}/g, "{{$1}}");
    }
    return super.interpolate(expr, params);
  }
}
